import React from "react";

import { OrderTagFilters } from "./shared/order-tag-filters";
import { useOrderTagExclusions } from "./use-order-tag-exclusions";

export function OrderTagExclusions() {
  const {
    isSynced,
    loading,
    tagBasedOrderExclusions,
    updateTagOrderExclusionByIndex,
    createTagOrderExclusions,
    removeTagBasedOrderExclusion,
  } = useOrderTagExclusions();

  return (
    <OrderTagFilters
      title="Order tag exclusions"
      subheader="You can use order tags to exclude certain purchases from attribution.
      You might want to do this if you have wholesale orders, for example."
      description="Exclude orders with the following tags from your Northbeam data"
      isSynced={isSynced}
      loading={loading}
      tagFilters={tagBasedOrderExclusions}
      updateTagFilters={updateTagOrderExclusionByIndex}
      createTagFilters={createTagOrderExclusions}
      removeTagFilters={removeTagBasedOrderExclusion}
    />
  );
}
